<template>
	<div class="small-12 large-2 primaryNav bgDark border-right light flex animated fadeIn" v-if="user">
		<div class="small-12 columns primaryWrap">
			<div class="small-12 columns flex justify-between vertical-align logo">
				<router-link :to="{ name: 'Dashboard' }">
					<img :src="logo" width="60" alt="Nestd Logo">
				</router-link>
				<a class="flex vertical-align">
					<i class="material-icons-outlined">menu_open</i>
				</a>
			</div>
			<div class="small-12 nav">
				<nav class="small-12 flex">
					<ul class="small-12 flex">
						<li class="small-12">
							<router-link class="flex vertical-align" :to="{ name: 'Dashboard' }">
								<i class="material-icons-outlined transition">dashboard</i>
								Dashboard
							</router-link>
						</li>
						<li class="small-12">
							<router-link class="flex vertical-align router-link-exact-active router-link-active" :to="{ name: 'PropertiesDashboard' }" v-if="$route.name == 'PropertyDetails' || $route.name == 'AddProperty' || $route.name == 'PropertyResidents' || $route.name == 'Resident' || $route.name == 'PropertyUnits' || $route.name == 'PropertyLeases' || $route.name == 'LeaseRent' || $route.name == 'Unit'">
								<i class="material-icons-outlined transition">home_work</i>
								Properties
							</router-link>
							<router-link class="flex vertical-align" :to="{ name: 'PropertiesDashboard' }" v-else>
								<i class="material-icons-outlined transition">home_work</i>
								Properties
							</router-link>
						</li>
					</ul>
				</nav>
			</div>
			<div class="small-12 columns navSection favorites">
				<a class="small-12 columns flex justify-between vertical-align">
					Favorites
					<i class="material-icons-outlined">expand_more</i>
				</a>
			</div>
			<div class="small-12 columns navSection favorites border-top dark">
				<a class="small-12 columns flex justify-between vertical-align">
					Reports	
					<i class="material-icons-outlined">expand_more</i>
				</a>
			</div>
		</div>
		<div class="userNav small-12 columns flex vertical-align">
			<router-link :to="{ name: 'SettingsAccount' }" class="flex small-12 columns vertical-align">
				<span class="float-left round bgPink flex vertical-align justify-center">
					<i class="material-icons">settings</i>
				</span>
				Account Settings
			</router-link>
		</div>
	</div>
</template>

<script>

	// Import the mixins
	import { AbbreviateNameFilter } from '@/mixins/filters/AbbreviateNameFilter'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'PrimaryNav',

		/*
		**  Register the mixins
		*/

		mixins: [

			AbbreviateNameFilter

		],

		/*
		** Set the props
		*/

		props: {

			user: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			logo: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/logos%2Fnestd-logo-white-blue.png?alt=media&token=272542a0-1fe8-4d92-b19d-145c876d39e4',
			future_item: false

		}),

		/*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			avatarBackground: function() {

				return 'background:url(' + this.user.links.avatar + ') no-repeat center/cover';

			}

		}

	}

</script>